import { BillingInfo, SubscriptionPlan } from "@onmo/graphql/graphql";

export type BillingRegion = "IN" | "ES";

const SPANISH_TAX_ID = /^[XYZ\d]\d{7}[A-Z]$/;
const SPANISH_POSTAL_CODE = /^\d{5}$/;

// Plans without a region predate Spain, so they keep the Indian flow
export const getBillingRegion = (
  plan?: Pick<SubscriptionPlan, "region"> | null,
): BillingRegion => (plan?.region?.toUpperCase() === "ES" ? "ES" : "IN");

export const isBillingRequired = (region: BillingRegion) => region === "IN";

export const hasBillingInfo = (
  billingInfo?: Pick<BillingInfo, "name" | "state"> | null,
) => !!billingInfo?.name && !!billingInfo?.state;

export const normalizeSpanishTaxId = (taxId: string) =>
  taxId.trim().toUpperCase();

export const isValidSpanishTaxId = (taxId: string) =>
  SPANISH_TAX_ID.test(normalizeSpanishTaxId(taxId));

export const isValidSpanishPostalCode = (postalCode: string) =>
  SPANISH_POSTAL_CODE.test(postalCode.trim());
